import { Component, inject, Inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { TareaService } from '../../services/tarea.service';
import { MatProgressBar } from '@angular/material/progress-bar';
import { ScnackbarData, SnackbarStyles, ToastService } from '../toast.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-dlg-recuperar',
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatProgressBar,
    ReactiveFormsModule, FormsModule,
    MatInputModule
  ],
  templateUrl: './dlg-recuperar.component.html',
  styleUrl: './dlg-recuperar.component.scss',
})
export class DlgRecuperarComponent {
  readonly data = inject<any>(MAT_DIALOG_DATA);
  private readonly tareaService = inject(TareaService);
  saving = false;
  formRecuperar = new FormGroup({
    motivo: new FormControl(''),
  });

  constructor(
    public dialogRef: MatDialogRef<DlgRecuperarComponent>, 
    private toast: ToastService,   
  ) {
    
  }

  onAceptar() {
    if (!this.formRecuperar.get('motivo')?.value) {
      return;
    }
    this.saving = true;
    const accionTarea = {
      id: this.data.idTarea,
      comentario: this.formRecuperar.get('motivo')?.value||'',
      idParticipante: 0,
      fechaExpira: ""
    };
    this.tareaService.recuperarTarea(accionTarea).subscribe({
      next: (res) => {
        this.saving = false;
        this.dialogRef.close(true);
      },
      error: (err: HttpErrorResponse) => {
        this.saving = false;
        this.dialogRef.close(false);
        const snackbarData: ScnackbarData = {
            message: "Recuperar no ejecutado",
            style: SnackbarStyles.Error,
            iconName: "error"
          }
        if (err.status == 406) {
          snackbarData.message= "Error: " + err.error;          
        }
        this.toast.show(snackbarData)
        console.error("Error al registrar la recuperación de la tarea", err);        
      }
    });
  }
}
